import { Reveal, SectionHead } from "./Reveal";

const questions = [
  {
    q: "Do you bring water and power?",
    a: "DARK brings its own power. We currently require access to a standard outdoor water source at the service location.",
  },
  {
    q: "How long does a service take?",
    a: "Timing depends on vehicle size, condition, and service level. We confirm the expected service window after reviewing your request.",
  },
  {
    q: "Where do you provide service?",
    a: "We serve the Kansas City metro across Kansas and Missouri, at homes and workplaces where the service can be performed safely.",
  },
  {
    q: "Can the final price change?",
    a: "Starting prices are based on typical vehicle size and condition. If your vehicle needs more work, we confirm the adjusted price before service begins.",
  },
  {
    q: "How does scheduling work?",
    a: "Send a service request with your preferred day. We review the vehicle details and contact you to confirm the service and appointment window.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-28 sm:py-40 px-5 sm:px-8 border-t border-graphite/60">
    <div className="max-w-5xl mx-auto">
      <SectionHead
        index="05"
        overline="Before We Arrive"
        title="What to know before service."
        copy="A few simple details make mobile service smoother for everyone."
      />
      <div className="mt-16 divide-y divide-graphite">
        {questions.map((item, i) => (
          <Reveal key={item.q} delay={i * 0.05}>
            <div className="py-8 grid md:grid-cols-[0.8fr_1.2fr] gap-4 md:gap-10">
              <h3 className="font-accent text-xs tracking-[0.24em] uppercase text-ivory">{item.q}</h3>
              <p className="text-sm text-silver/70 leading-relaxed">{item.a}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
